import React from "react";

const VerificationPassportIcon = ({ className }) => (
  <svg
    className={className}
    width="28"
    height="33"
    viewBox="0 0 28 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.1334 10.3667L17.1334 0.366669C16.8984 0.131669 16.5817 0 16.25 0H6.25C2.22 0 0 2.22 0 6.25V26.25C0 30.28 2.22 32.5 6.25 32.5H21.25C25.28 32.5 27.5 30.28 27.5 26.25V11.25C27.5 10.9183 27.3684 10.6 27.1334 10.3667ZM17.5 4.26834L23.2316 10H21.25C18.6217 10 17.5 8.87833 17.5 6.25V4.26834ZM25 26.25C25 28.8783 23.8783 30 21.25 30H6.25C3.62167 30 2.5 28.8783 2.5 26.25V6.25C2.5 3.62167 3.62167 2.5 6.25 2.5H15V6.25C15 10.28 17.22 12.5 21.25 12.5H25V26.25ZM13.75 20.5C15.955 20.5 17.7498 18.7067 17.7498 16.5C17.7498 14.295 15.955 12.5 13.75 12.5C11.545 12.5 9.75016 14.295 9.75016 16.5C9.75016 18.7067 11.545 20.5 13.75 20.5ZM13.75 15C14.5767 15 15.2498 15.6733 15.2498 16.5C15.2498 17.3283 14.5767 18 13.75 18C12.9233 18 12.2502 17.3283 12.2502 16.5C12.2502 15.6733 12.9233 15 13.75 15ZM20 26.5783V27.0833C20 27.7733 19.44 28.3333 18.75 28.3333C18.06 28.3333 17.5 27.7733 17.5 27.0833V26.5783C17.5 25.3767 16.6718 24.1667 14.8201 24.1667H12.6815C10.8298 24.1667 10.0016 25.3783 10.0016 26.5783V27.0833C10.0016 27.7733 9.44163 28.3333 8.75163 28.3333C8.06163 28.3333 7.50163 27.7733 7.50163 27.0833V26.5783C7.50163 24.1367 9.27981 21.6667 12.6815 21.6667H14.8201C18.2218 21.6667 20 24.1367 20 26.5783Z"
      fill="white"
    />
  </svg>
);

export default VerificationPassportIcon;
